export const PHONE_FORMATTING_PATTERNS = {
  US_CANADA: {
    pattern: (digits: string) => {
      if (digits.length <= 3) return digits;
      if (digits.length <= 6)
        return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
        6,
        10
      )}`;
    },
    countries: ["us", "ca"] as const,
  },
  UK: {
    pattern: (digits: string) => {
      if (digits.length <= 5) return digits;
      if (digits.length <= 8) return `${digits.slice(0, 5)} ${digits.slice(5)}`;
      return `${digits.slice(0, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
    },
    countries: ["gb"] as const,
  },
  DEFAULT: {
    pattern: (digits: string) => {
      if (digits.length <= 3) return digits;
      if (digits.length <= 6) return `${digits.slice(0, 3)} ${digits.slice(3)}`;
      if (digits.length <= 9)
        return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
      return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(
        6,
        9
      )} ${digits.slice(9)}`;
    },
    countries: [] as const,
  },
} as const;

export const DEFAULT_VALUES = {
  DEFAULT_COUNTRY: "gb",
  PREFERRED_COUNTRIES: ["us", "gb", "ca", "au"],
  PLACEHOLDER: "Enter phone number",
  ERROR_MESSAGE: "Please enter a valid phone number",
};

export const WIDTH_CALCULATION = {
  BASE_WIDTH: 64,
  CHAR_WIDTH: 7,
  WIDTH_STEPS: {
    80: "w-[80px]",
    85: "w-[85px]",
    90: "w-[90px]",
    95: "w-[95px]",
    100: "w-[100px]",
    110: "w-[110px]",
    120: "w-[120px]",
    DEFAULT: "w-[125px]",
  },
};

export const VALIDATION_MESSAGES = {
  INVALID_PHONE: "Please enter a valid phone number",
};
